import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stop-record",
  "use": "icon-stop-record-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-stop-record\">\n    <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(3 3)\">\n        <circle cx=\"9\" cy=\"9\" r=\"9\" fill=\"#4F8BFF\" />\n        <rect width=\"6\" height=\"6\" x=\"6\" y=\"6\" fill=\"#FFF\" rx=\"1\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol